import { assignInlineVars } from '@vanilla-extract/dynamic'
import { Text } from 'ui/src/components/Text/Text'
import { wrapper, amountBar, amountBarFilledPortion, percentageLabel } from './ReviewsDistributionByScore.css'
import { Stars } from './Stars'

type Props = {
  score: number
  percentage: number
}

export const ReviewsDistributionByScore = (props: Props) => {
  return (
    <div className={wrapper}>
      <Stars score={props.score} />
      <div
        className={amountBar}
        style={assignInlineVars({ [amountBarFilledPortion]: `${props.percentage}%` })}
        role="meter"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={props.percentage}
      />
      <Text as="span" className={percentageLabel}>
        {props.percentage + '%'}
      </Text>
    </div>
  )
}
